import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import gTabMenu from "@/components/g-tab-menu/g-tab-menu.vue";

const name = 'ParcelasPedidoEmAndamento'

export default {
  name,

  components:{ 
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
    "g-tab-menu": gTabMenu
  },

  props: { },

  mounted() { },

  updated() { },

  data() {
    return { 
        items: [
            {label: 'Detalhes', to: `/pedido-expedido-faturado-fluxo/${this.$route.params.id}/detalhes-pedido-expedido-faturado`,  flag: true, index: 0},
            {label: 'Histórico', to: `/pedido-expedido-faturado-fluxo/${this.$route.params.id}/historico-pedido-expedido-faturado`,  flag: false, index: 1},
            {label: 'Nota Fiscal', to: `/pedido-expedido-faturado-fluxo/${this.$route.params.id}/notaFiscal-pedido-expedido-faturado`,  flag: false, index: 2},
            {label: 'Parcelas', to: `/pedido-expedido-faturado-fluxo/${this.$route.params.id}/parcelas-pedido-expedido-faturado`,  flag: true, index: 3}
        ]
    }
  },

  methods: { 
  },

  computed: { }
};